import { Question } from '@jupiterone/jupiter-types/question';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Fade } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PackageIcon from 'react-feather/dist/icons/package';
import FavoriteIcon from 'react-feather/dist/icons/star';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    container: {
      borderRadius: 0,
      borderTop: 'solid 1px ' + theme.palette.grey[300],
      position: 'relative',
      zIndex: theme.zIndex.modal,
    },
    item: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: 'auto',
      padding: '8px 17px 8px 20px',
    },
    question: {
      flex: '1 1 auto',
      fontWeight: 'normal',
      lineHeight: 1.4,
      marginRight: theme.spacing(1),
      whiteSpace: 'normal',
    },
    itemIcon: {
      color: theme.palette.coolGrey[200],
      margin: 0,
      minWidth: 0,
    },
    instructions: {
      color: theme.palette.coolGrey[400],
      display: 'block',
      paddingLeft: theme.spacing(2.5),
      paddingBottom: theme.spacing(1),
    },
    instructionsNoneFound: {
      paddingTop: theme.spacing(1),
    },
    loadingBar: {
      height: 2,
      marginTop: -3,
    },
  })
);

interface Props {
  questions: Question[];
  onSelectQuestion: (question: Question) => void;
}

const SuggestedQuestions = ({ questions, onSelectQuestion }: Props) => {
  const classes = useStyles();
  return (
    <Fade in={true}>
      <Paper className={classes.container}>
        {questions.length > 0 ? (
          <MenuList>
            {[
              <Typography
                key={0}
                variant="caption"
                className={classes.instructions}
              >
                Hit ENTER to search or select a question from below
              </Typography>,
              questions.map((question) => (
                <MenuItem
                  key={question.id}
                  onClick={() => onSelectQuestion(question)}
                  classes={{ root: classes.item }}
                >
                  <Typography className={classes.question}>
                    {question.title}
                  </Typography>
                  <ListItemIcon className={classes.itemIcon}>
                    {question.accountId ? (
                      <Tooltip title="Saved query">
                        <FavoriteIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Packaged query">
                        <PackageIcon />
                      </Tooltip>
                    )}
                  </ListItemIcon>
                </MenuItem>
              )),
            ]}
          </MenuList>
        ) : (
          <Typography
            variant="caption"
            className={clsx(
              classes.instructions,
              classes.instructionsNoneFound
            )}
          >
            No questions found, hit ENTER to perform a text search
          </Typography>
        )}
      </Paper>
    </Fade>
  );
};

export default SuggestedQuestions;
